import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useGetFundraisingStatusById = fundraisingId => {
  return useQuery({
    staleTime: 1000 * 60,
    enabled: !!fundraisingId,
    refetchOnWindowFocus: true,
    queryKey: [QUERY_KEYS.fundraising.status_by_id, fundraisingId],
    queryFn: () =>
      fundraisingService.statusById(fundraisingId).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
